<template>
  <el-button type="primary" icon="el-icon-upload">批量上报</el-button>
</template>

<script>
export default {
  name: 'ReportButton'
}
</script>

<style>
</style>
